import { Alert, AlertDescription, AlertIcon, AlertTitle, Box } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { PortalLifecycleStatus, type PortalSourcingEventDetailDto } from "../../../../autogen/bff-api";

// Looked up dynamically by status, so langen can't see these statically:
// t("The bid deadline has passed") t("Bids are under evaluation")
// t("This procurement has been awarded") t("This procurement has been cancelled")
// t("This procurement has concluded")
const MESSAGE: Partial<Record<PortalLifecycleStatus, string>> = {
  [PortalLifecycleStatus.DeadlinePassed]: "The bid deadline has passed",
  [PortalLifecycleStatus.UnderEvaluation]: "Bids are under evaluation",
  [PortalLifecycleStatus.Awarded]: "This procurement has been awarded",
  [PortalLifecycleStatus.Cancelled]: "This procurement has been cancelled",
  [PortalLifecycleStatus.Concluded]: "This procurement has concluded",
};

export const EventLifecycleBanner = ({ event }: { event: PortalSourcingEventDetailDto }) => {
  const { t } = useTranslation();
  const status = event.lifecycle.status;
  const message = MESSAGE[status];
  if (status === PortalLifecycleStatus.Open || !message) return null;

  const isCancelled = status === PortalLifecycleStatus.Cancelled;
  const chakraStatus = isCancelled ? "error" : status === PortalLifecycleStatus.DeadlinePassed ? "warning" : "info";

  return (
    <Alert status={chakraStatus} variant="subtle" rounded="md">
      <AlertIcon />
      <Box>
        <AlertTitle>{t(message)}</AlertTitle>
        {isCancelled && event.lifecycle.cancelledReason && (
          <AlertDescription>{event.lifecycle.cancelledReason}</AlertDescription>
        )}
      </Box>
    </Alert>
  );
};
